import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GeneralCache } from 'src/app/classes/app/general-cache';


export type CreatorMode = 'city_from_theme_idea' | 'plot_from_city_theme';

export interface ILeplaceChatWidgetPrefill {
    source?: 'website' | 'lp_connect' | 'lp_town' | 'leplace_world';
    name?: string;
    email?: string;
    device_type?: 'browser' | 'ios' | 'android';
    device_model?: string;
    os_version?: string;

    // customer lane
    booking_date?: string; // YYYY-MM-DD
    booking_reference?: string;
    tour_name?: string;
    story_id?: string | number;

    // creator lane
    creator_mode?: CreatorMode;
    creator_theme?: string;
    creator_idea?: string;
    creator_city?: string;
}


@Component({
    selector: 'leplace-chat-widget',
    templateUrl: './leplace-chat-widget.component.html',
    styleUrls: ['./leplace-chat-widget.component.scss']
})
export class LeplaceChatWidgetComponent implements AfterViewInit, OnDestroy, OnChanges {
    @Input() widgetHost = 'https://monitor.leplace-api.com:8800';
    @Input() widgetPath = '/ui/widget/index.html'; // '/ui/widget/index_creator.html'
    @Input() lane: 'customer' | 'creator' = 'customer';
    @Input() title = 'Geo Support';
    @Input() apiBaseUrl = 'https://monitor.leplace-api.com:8800';
    @Input() authBaseUrl = 'https://leplace.leplace-api.com';
    @Input() authToken = '';
    @Input() openOnLoad = false;
    @Input() source = 'lp_connect';
    @Input() enableSupportSessionAuth = true;
    @Input() supportSessionAuthEndpoint = '/support-user/register-support-user-session';
    @Input() prefill: ILeplaceChatWidgetPrefill = {};

    @ViewChild('frame', { static: true }) frameRef!: ElementRef<HTMLIFrameElement>;

    isOpen = false;

    safeSrc!: SafeResourceUrl;
    private frameOrigin = '';

    constructor(private sanitizer: DomSanitizer) { }

    private onMessage = (event: MessageEvent) => {
        if (event.origin !== this.widgetHost) return;
        if (event.data?.type !== 'LEPLACE_WIDGET_STATE') return;
        this.isOpen = !!event.data.payload?.open;
    };

    get src(): string {
        const q = new URLSearchParams({
            title: this.title,
            lane: this.lane,
            openOnLoad: String(this.openOnLoad)
        });
        return `${this.widgetHost}${this.widgetPath}?${q.toString()}`;
    }

    ngAfterViewInit(): void {
        window.addEventListener('message', this.onMessage);
    }

    ngOnChanges(): void {
        const url = new URL(this.widgetPath, this.widgetHost); // supports relative path
        url.searchParams.set('title', this.title);
        url.searchParams.set('lane', this.lane);
        url.searchParams.set('openOnLoad', String(this.openOnLoad));

        this.frameOrigin = url.origin; // use this for postMessage
        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
    }

    ngOnDestroy(): void {
        window.removeEventListener('message', this.onMessage);
    }

    onLoad(): void {
        this.frameRef.nativeElement.contentWindow?.postMessage({
            type: 'LEPLACE_WIDGET_INIT',
            payload: {
                title: this.title,
                lane: this.lane,
                source: this.source,
                apiBaseUrl: this.apiBaseUrl,
                authBaseUrl: this.authBaseUrl,
                authToken: this.authToken,
                enableSupportSessionAuth: this.enableSupportSessionAuth,
                supportSessionAuthEndpoint: this.supportSessionAuthEndpoint,
                prefill: this.prefill,
                notify: !GeneralCache.isDev
            }
        }, this.frameOrigin);
    }
}
